var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgCirclePlusBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "kpmg-circle-plus-blue_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M720 464H560V304a48 48 0 10-96 0v160H304a48 48 0 100 96h160v160a48 48 0 1096 0V560h160a48 48 0 100-96zM512 0C229.232 0 0 229.232 0 512s229.232 512 512 512 512-229.232 512-512S794.768 0 512 0zm0 928C282.256 928 96 741.744 96 512 96 282.24 282.256 96 512 96s416 186.256 416 416-186.256 416-416 416z",
    fill: "#009ceb"
  })));
}

export default SvgKpmgCirclePlusBlue;